import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TenantLegalAgreementStatusResponse } from 'app/models/api/data-privacy';
import { API_ENDPOINT } from 'app/services/utils.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DataPrivacyService {
  private http = inject(HttpClient);

  private readonly sapConnectorAgreementEndpoint = `${API_ENDPOINT}/data-privacy/sap-connector`;
  private readonly pushNotificationsAgreementEndpoint = `${API_ENDPOINT}/data-privacy/push-notifications`;


  acceptSapConnectorUsageAgreement(): Observable<TenantLegalAgreementStatusResponse> {
    return this.http.get<TenantLegalAgreementStatusResponse>(this.sapConnectorAgreementEndpoint);
  }

  acceptPushNotificationTermsOfUsage(): Observable<TenantLegalAgreementStatusResponse> {
    return this.http.post<TenantLegalAgreementStatusResponse>(this.pushNotificationsAgreementEndpoint, {});
  }

  deletePushNotificationTermsOfUsage(): Observable<unknown> {
    return this.http.delete(this.pushNotificationsAgreementEndpoint);
  }
}
